"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosContactItemSchema = exports.APosReceiptEmailContactResultSchema = exports.APosReceiptEmailStatusSchema = exports.APosReceiptEmailRequestSchema = void 0;
const zod_1 = require("zod");
/**
 * Email receipts from the customer display (spec Part 4).
 * POST /receipts/email on pos-sales-service accepts APosReceiptEmailRequest;
 * the transaction row records APosReceiptEmailStatus as `receiptEmail`.
 * pos-sales-service mirrors the request schema locally (no shared-types
 * dependency) and pins the mirror to this file's built dist in a test.
 */
exports.APosReceiptEmailRequestSchema = zod_1.z.object({
    transactionId: zod_1.z.string().min(1),
    locationId: zod_1.z.string().min(1),
    email: zod_1.z.string().email(),
    saveToMember: zod_1.z.boolean().default(false),
    marketingOptIn: zod_1.z.boolean().default(false),
    memberId: zod_1.z.string().nullable().optional(),
});
exports.APosReceiptEmailStatusSchema = zod_1.z.object({
    to: zod_1.z.string(), // masked
    sentAt: zod_1.z.number().int().optional(),
    status: zod_1.z.enum(['queued', 'sent', 'failed']),
});
/** `contact` field of the POST /receipts/email response. */
exports.APosReceiptEmailContactResultSchema = zod_1.z.enum(['member', 'contact', 'none']);
/** One row of GET /contacts (pos-loyalty-service). createdAt is ms, or ISO on rows converted from older data. */
exports.APosContactItemSchema = zod_1.z.object({
    customerId: zod_1.z.string(),
    email: zod_1.z.string(),
    source: zod_1.z.string(),
    marketingOptIn: zod_1.z.boolean(),
    marketingOptInAt: zod_1.z.number().int().optional(),
    createdAt: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
    lastSeenAt: zod_1.z.number().int().optional(),
    locationId: zod_1.z.string(),
});
//# sourceMappingURL=pos-receipt-email.schema.js.map